import { http } from "@/core/api/";
import qs from 'qs';

const apiUrl = "api/confrelatedserviceacademicweek";

export const getInitFilters = async () =>
  await http.get(`${apiUrl}/initfilters`);

export const validateCurrentYearWeeksConfiguration = async () =>
  await http.get(`${apiUrl}/validate/currentyear`);
  
export const validateFutureYearWeeksConfiguration = async () =>
  await http.get(`${apiUrl}/validate/futureyear`);

export const generateCurrentYearWeeksConfiguration = async () =>
  await http.post(`${apiUrl}/generate/currentyear`);
  
export const generateFutureYearWeeksConfiguration = async () =>
  await http.post(`${apiUrl}/generate/futureyear`);

export const search = async (params) =>
  await http.get(`${apiUrl}/search`, {
    params,
  });

export const updateWeekStatusFlags = async (payload) =>
  await http.put(`${apiUrl}/updateweekstatusflag`, payload);

export const saveWeekDetails = async (payload) =>
  await http.put(`${apiUrl}/saveweekdetails`, payload);

export const getWeekHistory = async (params) =>
  await http.get(`${apiUrl}/history`, {
    params,
  });

export const validateIsVisitInWeekRange = async (params) =>
  await http.get(`${apiUrl}/validateweekrange`, {
    params,
  });

export const validateIsAnyVisitInDates = async (dates) =>
  await http.get(`${apiUrl}/validatedates`, {
    params: { dates },
    paramsSerializer: params => qs.stringify(params),
  });